<template>
    <div class="logo-default">
        <a
            @click="onClick"
        >
            <img 
                src="@/assets/images/logo-default.png" 
                alt="MAKRO Twój sukces to nasz biznes"
                class="logo-default-desktop"
            >
            <img 
                src="@/assets/images/logo-mobile.png" 
                alt="MAKRO Twój sukces to nasz biznes"
                class="logo-default-mobile"
            >
        </a>
    </div>
</template>

<script>
export default {
    computed: {
        isStudentAuth() {
            return this.$store.getters['apiStudent/isAuth']
        }
    },

    methods: {
        onClick() {
            if (!this.isStudentAuth) {
                 window.open('https://www.makro.pl/')
            }

            this.$store.dispatch('siteLoader/open')

            this.$store.dispatch('apiAuth/logout')
                .then(() => {
                    this.$store.dispatch('siteLoader/close')
                    this.$router.push({ name: 'index' })
                })
        }
    }
}
</script>

<style lang="scss">
.logo-default {
    > a {
        cursor: pointer;
    }

    &-mobile {
        display: none;
    }

    @media (max-width: $screen-mobile-landscape) {
        &-desktop {
            display: none;
        }

        &-mobile {
            display: inline-block;
        }
    }
}
</style>